/**
 * Details & Benefits ingredients accordion.
 *
 * Keeps one row open at a time within a block. Closing is handed to the
 * <collapsible-row> element's own shrink() so it animates exactly like a manual
 * close, and that element stays the only owner of the open state.
 *
 * Delegated from the document so rows re-rendered by the theme editor are
 * covered without re-initialising.
 */
document.addEventListener("click", (event) => {
    const summary = event.target.closest(
        ".details-and-benefits__module summary",
    );
    if (!summary) return;

    const row = summary.closest(".details-and-benefits__module");
    const group = row?.closest(".details-and-benefits__tables");
    if (!group) return;

    group.querySelectorAll(".details-and-benefits__module").forEach((other) => {
        if (other === row) return;

        const details = other.querySelector("details");
        if (!details || !details.open) return;

        if (typeof other.shrink === "function") {
            // Mirrors what <collapsible-row> does on its own summary click.
            details.style.overflow = "hidden";
            other.shrink();
        } else {
            // Custom element never upgraded (app.js blocked or errored).
            details.removeAttribute("open");
        }
    });
});
